module.exports = __webpack_public_path__ + "assets/discount-b1190a.svg";